const PaymentVoucher = {
    searchGlAccount: () => "store/customer/account/search",
    createPaymentVoucher: () => "store/voucher",
    paymentVoucherHistory: () => 'store/voucher',
    voucherHistoryDownload: (id: string) => `store/voucher/download/${id}`,
}

export default PaymentVoucher